import { fontWeights } from './fontWeights';
/**
 * Breakpoint configuration, this is exposed through theme.media.breakpoint
 */
const breakpoint = {
    /**
     * 20em / 320px
     */
    xxs: '20em',
    /**
     * 23.4375em / 375px
     */
    xs: '23.4375em',
    /**
     * 48em / 768px
     */
    s: '48em',
    /**
     * 64em / 1024px
     */
    m: '64em',
    /**
     * 90em / 1440px
     */
    l: '90em',
    /**
     * 120em / 1920px
     */
    xl: '120em',
};
/**
 * Colors of Design system 1.0.
 * @deprecated Use colorsV2 instead
 */
const colorV1 = {
    /**
     * Main color / Matisse blue / Lake
     * @deprecated Use lake instead
     */
    matisseBlue: '#0046AD',
    /**
     * @deprecated Use lake100 instead
     */
    matisseBlue100: '#0046AD',
    /**
     * Main color / Zodiac black / Coal
     * @deprecated Use coal instead
     */
    zodiacBlack: '#212322',
    /**
     * @deprecated Use coal100 instead
     */
    zodiacBlack100: '#212322',
    /**
     * Status color / Okay green
     * No other shades available
     * @deprecated Use colorV2 instead
     */
    okayGreen: '#00773E',
    /**
     * Status color / Attention red
     * No other shades available
     * @deprecated Use colorV2 instead
     */
    attentionRed: '#DA0900',
    // Secondary colors
    /**
     * @deprecated Use coal65 instead
     */
    zodiacBlack65: '#6F706F',
    /**
     * @deprecated Use coal22 instead
     */
    zodiacBlack22: '#CECFCE',
    /**
     * @deprecated Use coal15 instead
     */
    zodiacBlack15: '#DEDEDE',
    /**
     * @deprecated Use coal08 instead
     */
    zodiacBlack08: '#EDEDED',
    /**
     * @deprecated Use coal04 instead
     */
    zodiacBlack04: '#F6F6F6',
    /**
     * @deprecated Use coal02 instead
     */
    zodiacBlack02: '#FBFBFB',
    /**
     * Coral red / Lingonberry Porridge
     * @deprecated Use lingonberryPorridge instead
     */
    coralRed: '#F09591',
    /**
     * @deprecated Use lingonberryPorridge150 instead
     */
    coralRed150: '#890D47',
    /**
     * @deprecated Use lingonberryPorridge100 instead
     */
    coralRed100: '#F09591',
    /**
     * @deprecated Use lingonberryPorridge40 instead
     */
    coralRed40: '#F9D5D3',
    /**
     * @deprecated Use lingonberryPorridge15 instead
     */
    coralRed15: '#FDEFEF',
    /**
     * @deprecated Use cloudberry instead
     */
    cadmiumYellow: '#FCD757',
    /**
     * @deprecated Use cloudberry150 instead
     */
    cadmiumYellow150: '#6A5200',
    /**
     * @deprecated Use cloudberry100 instead
     */
    cadmiumYellow100: '#FCD757',
    /**
     * @deprecated Use cloudberry40 instead
     */
    cadmiumYellow40: '#FEEFBC',
    /**
     * @deprecated Use cloudberry15 instead
     */
    cadmiumYellow15: '#FFF9E6',
    /**
     * Viridian green / Spruce
     * @deprecated Use spruce instead
     */
    viridianGreen: '#007672',
    /**
     * @deprecated Use spruce150 instead
     */
    viridianGreen150: '#005451',
    /**
     * @deprecated Use spruce100 instead
     */
    viridianGreen100: '#007672',
    /**
     * @deprecated Use spruce40 instead
     */
    viridianGreen40: '#99C8C7',
    /**
     * @deprecated Use spruce15 instead
     */
    viridianGreen15: '#D9EAEA',
    /**
     * Ruby red / Wild Raspberry
     * @deprecated Use wildRaspberry instead
     */
    rubyRed: '#CE0F69',
    /**
     * @deprecated Use wildRaspberry100 instead
     */
    rubyRed100: '#CE0F69',
    /**
     * @deprecated Use wildRaspberry40 instead
     */
    rubyRed40: '#EB9FC3',
    /**
     * @deprecated Use wildRaspberry15 instead
     */
    rubyRed15: '#F8DBE9',
    /**
     * Hazy purple / Heather
     * @deprecated Use heather instead
     */
    hazyPurple: '#8246AF',
    /**
     * @deprecated Use heather100 instead
     */
    hazyPurple100: '#8246AF',
    /**
     * @deprecated Use heather40 instead
     */
    hazyPurple40: '#CDB5DF',
    /**
     * @deprecated Use heather15 instead
     */
    hazyPurple15: '#ECE3F3',
    /**
     * @deprecated Use lake125 instead
     */
    matisseBlue125: '#083D8A',
    /**
     * @deprecated Use lake40 instead
     */
    matisseBlue40: '#99B5DE',
    /**
     * @deprecated Use lake15 instead
     */
    matisseBlue15: '#D9E3F3',
};
const colorV2 = {
    /**
     * Lake. A primary color. It used be called Matisse blue.
     */
    lake: '#0046AD',
    /**
     * Blueberry. A primary color.
     */
    blueberry: '#1A244A',
    /**
     * Coal. A primary color. It used to be called ZodiacBlack.
     */
    coal: '#212322',
    /**
     * Ice. A primary color.
     */
    ice: '#E8EDEE',
    /**
     * Woolhead. A primary color.
     */
    woolhead: '#FFFFFF',
    /**
     * Lake125. A secondary color.
     */
    lake125: '#083D8A',
    /**
     * Lake40. A secondary color.
     */
    lake40: '#99B5DE',
    /**
     * Lake15. A secondary color.
     */
    lake15: '#D9E3F3',
    /**
     * Lake05. A secondary color.
     */
    lake05: '#F0F5FC',
    /**
     * Spruce150. A secondary color.
     */
    spruce150: '#005451',
    /**
     * Spruce. A secondary color. It used to be called ViridianGreen.
     */
    spruce: '#007672',
    /**
     * Spruce40. A secondary color.
     */
    spruce40: '#99C8C7',
    /**
     * Spruce15. A secondary color.
     */
    spruce15: '#D9EAEA',
    /**
     * Cloudberry150. A secondary color.
     */
    cloudberry150: '#6A5200',
    /**
     * Cloudberry. A secondary color. It used to be called CadiumYellow.
     */
    cloudberry: '#FCD757',
    /**
     * Cloudberry40. A secondary color.
     */
    cloudBerry40: '#FEEFBC',
    /**
     * Cloudberry15. A secondary color.
     */
    cloudberry15: '#FFF9E6',
    /**
     * LingonberryPorridge150. A secondary color.
     */
    lingonberryPorridge150: '#890D47',
    /**
     * LingonberryPorridge. A secondary color. It used to be called CoralRed.
     */
    lingonberryPorridge: '#F09591',
    /**
     * LingonberryPorridge40. A secondary color.
     */
    lingonberryPorridge40: '#F9D5D3',
    /**
     * LingonberryPorridge15. A secondary color.
     */
    lingonberryPorridge15: '#FDEFEF',
    /**
     * Heather. A secondary color. It used to be called HazyPurple.
     */
    heather: '#8246AF',
    /**
     * Heather40. A secondary color.
     */
    heather40: '#CDB5DF',
    /**
     * Heather15. A secondary color.
     */
    heather15: '#ECE3F3',
    /**
     * WildRaspberry. A secondary color. It used to be called RubyRed.
     */
    wildRaspberry: '#CE0F69',
    /**
     * WildRaspberry. A secondary color.
     */
    wildRaspberry40: '#EB9FC3',
    /**
     * WildRaspberry. A secondary color.
     */
    wildRaspberry15: '#F8DBE9',
    /**
     * Coal65
     */
    coal65: '#6F6F6F',
    /**
     * Coal35
     */
    coal35: '#A8A8A8',
    /**
     * Coal22
     */
    coal22: '#CECECE',
    /**
     * Coal15
     */
    coal15: '#DEDEDE',
    /**
     * Coal12
     */
    coal12: '#E4E4E4',
    /**
     * Coal08
     */
    coal08: '#EDEDED',
    /**
     * Coal04
     */
    coal04: '#F6F6F6',
    /**
     * Coal02
     */
    coal02: '#FBFBFB',
    /**
     * SkyIsBlue. The accent color.
     */
    skyIsBlue: '#0063F6',
    /**
     * Black. Text on light background.
     */
    black: '#000000',
    /**
     * White. Text on dark background.
     */
    white: '#FFFFFF',
    /**
     * @deprecated RainyBlue. The color is not part of Design system 2.0.
     */
    rainyBlue: '#A4CBE1',
    /**
     * @deprecated RainyBlue100. The color is not part of Design system 2.0.
     */
    rainyBlue100: '#A4CBE1',
    /**
     * @deprecated RainyBlue40. The color is not part of Design system 2.0.
     */
    rainyBlue40: '#DBEAF3',
    /**
     * @deprecated RainyBlue15. The color is not part of Design system 2.0.
     */
    rainyBlue15: '#F1F7FB',
};
const semanticColor = {
    background: colorV2.coal04,
    hover: colorV2.skyIsBlue,
    attentionRed: colorV2.wildRaspberry,
    okayGreen: colorV2.spruce,
};
/**
 * Global structure for design tokens i.e. theme.
 */
export const theme = {
    /**
     * Metadata about the theme for future use.
     */
    _meta: {
        name: 'TTDS',
        version: '0.1',
    },
    border: {
        /**
         * Radiuses for borders. For circular elements 50% or another fitting value
         * can be used outside of these values
         */
        radius: {
            /**
             * 9999px, for pills and circles of any size
             */
            full: '9999px',
            /**
             * 2.5rem / 40px
             */
            xxl: '2.5rem',
            /**
             * 1.5rem / 24px
             */
            xl: '1.5rem',
            /**
             * 0.875rem / 14px
             */
            l: '0.875rem',
            /**
             * 0.5rem / 8px
             */
            m: '0.5rem',
            /**
             * 0.25rem / 4px
             */
            s: '0.25rem',
            /**
             * 0.125rem / 2px
             */
            xs: '0.125rem',
            /**
             * 0, to remove existing border radius
             */
            none: '0',
        },
        /**
         * Widths for borders.
         */
        width: {
            /**
             * 0.0625rem / 1px
             */
            xxs: '0.0625rem',
            /**
             * 0.125rem / 2px
             */
            xs: '0.125rem',
            /**
             * 0.25rem / 4px
             */
            s: '0.25rem',
        },
    },
    shadow: {
        /*
           Figma represent shadow color opacity in percentages, but here we use #RRGGBBAA hex format
           For a conversion table betweeh the two when adding new colors, you can use:
           https://gist.github.com/passiondroid/51fd6b3281c10d463361fa5eb5a1f22b
         */
        color: {
            /**
             * Zodiac Black 5%
             */
            card: `${colorV2.coal}0D`,
            cardLargeShadow: colorV2.coal04,
        },
        blur: {
            /**
             * 0.5rem / 8px
             */
            card: '0.5rem',
            cardLargeShadow: '2rem',
        },
        offset: {
            card: {
                /**
                 * 0
                 */
                x: '0',
                /**
                 * 0.25rem / 4px
                 */
                y: '0.25rem',
            },
            cardLargeShadow: {
                x: '0',
                y: '0.5rem',
            },
        },
    },
    media: {
        /**
         * Breakpoints for the common layouts. Note the em-format, some older browsers
         * don't like rem in the media queries. In media queries em is also resolved
         * with the base font size so this shouldn't matter for most cases.
         */
        breakpoint,
        /**
         * Predefined media queries which utilise the values from media.breakpoint
         */
        viewport: {
            /**
             * From "0" to 320px (20em)
             */
            xxs: `@media screen and (max-width: ${breakpoint.xxs})`,
            /**
             * From 320px (20em) to 375px (23.4375em)
             */
            xs: `@media screen and (min-width: ${breakpoint.xxs}) and (max-width: ${breakpoint.xs})`,
            /**
             * From 375px (23.4375em) to 768px (48em)
             */
            s: `@media screen and (min-width: ${breakpoint.xs}) and (max-width: ${breakpoint.s})`,
            /**
             * From 768px (48em) to 1024px (64em)
             */
            m: `@media screen and (min-width: ${breakpoint.s}) and (max-width: ${breakpoint.m})`,
            /**
             * From 1024px (64em) to 1440px (90em)
             */
            l: `@media screen and (min-width: ${breakpoint.m}) and (max-width: ${breakpoint.l})`,
            /**
             * From 1440px (90em) to 1920px (120em)
             */
            xl: `@media screen and (min-width: ${breakpoint.l}) and (max-width: ${breakpoint.xl})`,
            /**
             * From 1920px (120em) onwards
             */
            xxl: `@media screen and (min-width: ${breakpoint.xl})`,
            /**
             * Helper to divide styles for small (likely mobile touch devices) and larger devices
             */
            notSmall: `@media screen and (min-width: ${breakpoint.s})`,
        },
        /**
         * Common device related media queries such as hover support and pointer/touch configurations
         */
        device: {
            /**
             * Supports hover effects, determined from hover: hover media query
             */
            supportsHover: '@media (hover: hover)',
            /**
             * Is primarily a touch screen device, determined from hover: none & pointer: coarse media query
             */
            usesTouchPrimarily: '@media (hover: none) and (pointer: coarse)',
            /**
             * Is primarily a device with a cursor/pointer, determined from hover: hover & pointer: fine media query
             */
            usesPointerPrimarily: '@media (hover: hover) and (pointer: fine)',
        },
    },
    /**
     * Color palette in rrggbb hex color notation. If there is a need to add opacity
     * for the colors you can suffix the opacity using rrggbbaa notation (or convert the hex notation to rgba).
     */
    color: { ...colorV1, ...colorV2, ...semanticColor },
    /**
     * Spacing values to be used with margins, paddings etc.
     * The key's correspond with the values in order to allow for easier
     * management and usage of the list.
     */
    spacing: {
        /**
         * 0rem / 0px
         */
        '0': '0rem',
        /**
         * 0.25rem / 4px
         */
        '0_25': '0.25rem',
        /**
         * 0.5rem / 8px
         */
        '0_5': '0.5rem',
        /**
         * 0.75rem / 12px
         */
        '0_75': '0.75rem',
        /**
         * 1rem / 16px
         */
        '1': '1rem',
        /**
         * 1.5rem / 24px
         */
        '1_5': '1.5rem',
        /**
         * 2rem / 32px
         */
        '2': '2rem',
        /**
         * 2.5rem / 40px
         */
        '2_5': '2.5rem',
        /**
         * 3rem / 48px
         */
        '3': '3rem',
        /**
         * 3.5rem / 56px
         */
        '3_5': '3.5rem',
        /**
         * 4rem / 64px
         */
        '4': '4rem',
        /**
         * 4.5rem / 72px
         */
        '4_5': '4.5rem',
        /**
         * 5rem / 80px
         */
        '5': '5rem',
        /**
         * 5.5rem / 88px
         */
        '5_5': '5.5rem',
        /**
         * 6rem / 96px
         */
        '6': '6rem',
        /**
         * 9rem / 144px
         */
        '9': '9rem',
    },
    typography: {
        /**
         * Font families for the different typographic components
         */
        fontFamily: {
            title: 'KabelStd, sans-serif',
            subtitle: 'TerveystaloSans, sans-serif',
            body: 'TerveystaloSans, sans-serif',
            lead: 'TerveystaloSans, sans-serif',
            list: 'TerveystaloSans, sans-serif',
            listNumber: 'KabelStd, sans-serif',
            button: 'TerveystaloSans, sans-serif',
        },
        /**
         * Line heights for the different typographic components. These should correspond to the font sizes
         * with the same Size key.
         */
        lineHeight: {
            title: {
                /**
                 * 6.875rem / 110px
                 */
                xxxl: '6.875rem',
                /**
                 * 4.3125rem / 69px
                 */
                xxl: '4.3125rem',
                /**
                 * 2.875rem / 46px
                 */
                xl: '2.875rem',
                /**
                 * 2.375rem / 38px
                 */
                l: '2.375rem',
            },
            subtitle: {
                /**
                 * 4rem / 64px
                 */
                xxl: '4rem',
                /**
                 * 3.125rem / 50px
                 */
                xl: '3.125rem',
                /**
                 * 2.625rem / 42px
                 */
                l: '2.625rem',
                /**
                 * 2.125rem / 34px
                 */
                mplus: '2.125rem',
                /**
                 * 1.8125rem / 29px
                 */
                m: '1.8125rem',
                /**
                 * 1.5625rem / 25px
                 */
                s: '1.5625rem',
                /**
                 * 1.5rem / 24px
                 */
                xs: '1.5rem',
            },
            body: {
                /**
                 * 1.5625rem / 25px
                 */
                l: '1.5625rem',
                /**
                 * 1.5rem / 24px
                 */
                m: '1.5rem',
            },
            lead: {
                /**
                 * 2rem / 32px
                 */
                m: '2rem',
                /**
                 * 1.75rem / 28px
                 */
                s: '1.75rem',
            },
            list: {
                /**
                 * 1.75rem / 28px
                 */
                m: '1.75rem',
            },
            listNumber: {
                /**
                 * 1.75rem / 28px
                 */
                m: '1.75rem',
            },
            button: {
                /**
                 * 1.8125rem / 29px
                 */
                m: '1.8125rem',
            },
        },
        /**
         * Font sizes for the different typographic components. These should correspond to the line heights
         * with the same key.
         */
        fontSize: {
            title: {
                /**
                 *  6rem / 96px
                 */
                xxxl: '6rem',
                /**
                 *  3.75rem / 60px
                 */
                xxl: '3.75rem',
                /**
                 * 2.5rem / 40px
                 */
                xl: '2.5rem',
                /**
                 * 2rem / 32px
                 */
                l: '2rem',
            },
            subtitle: {
                /**
                 * 2.875rem / 46px
                 */
                xxl: '2.875rem',
                /**
                 * 2.25rem / 36px
                 */
                xl: '2.25rem',
                /**
                 * 1.875rem / 30px
                 */
                l: '1.875rem',
                /**
                 * 1.5rem / 24px
                 */
                mplus: '1.5rem',
                /**
                 * 1.3125rem / 21px
                 */
                m: '1.3125rem',
                /**
                 * 1.125rem / 18px
                 */
                s: '1.125rem',
                /**
                 * 1rem / 16px
                 */
                xs: '1rem',
            },
            body: {
                /**
                 * 1.125rem / 18px
                 */
                l: '1.125rem',
                /**
                 * 1rem / 16px
                 */
                m: '1rem',
            },
            lead: {
                /**
                 * 1.3125rem / 21px
                 */
                m: '1.3125rem',
                /**
                 * 1.0625rem / 17px
                 */
                s: '1.0625rem',
            },
            list: {
                /**
                 * 1.25rem / 20px
                 */
                m: '1.25rem',
            },
            listNumber: {
                /**
                 * 1.25rem / 20px
                 */
                m: '1.25rem',
            },
            button: {
                /**
                 * 1.3125rem / 21px
                 */
                m: '1.3125rem',
            },
        },
        /**
         * Global font weights, these match the available font files
         */
        fontWeight: {
            title: fontWeights.black,
            subtitle: fontWeights.bold,
            body: fontWeights.normal,
            lead: fontWeights.light,
            list: fontWeights.light,
            listNumber: fontWeights.black,
            button: fontWeights.bold,
            /**
             * @deprecated use fontWeights export instead.
             */
            thin: 100,
            /**
             * @deprecated use fontWeights export instead.
             */
            light: 300,
            /**
             * @deprecated use fontWeights export instead.
             */
            normal: 400,
            /**
             * @deprecated use fontWeights export instead.
             */
            bold: 700,
            /**
             * @deprecated use fontWeights export instead.
             */
            extraBold: 800,
            /**
             * @deprecated use fontWeights export instead.
             */
            black: 900,
        },
        letterSpacing: {
            body: {
                /**
                 * 0.01em / 1%
                 */
                l: '0.01em',
                /**
                 * 0.01em / 1%
                 */
                m: '0.01em',
            },
            title: {
                /**
                 * -0.015em / -1.5%
                 */
                xxxl: '-0.015em',
                /**
                 * -0.015em / -1.5%
                 */
                xxl: '-0.015em',
                /**
                 * -0.015em / -1.5%
                 */
                xl: '-0.015em',
                /**
                 * -0.01em / -1%
                 */
                l: '-0.01em',
            },
            subtitle: {
                xxl: 'normal',
                xl: 'normal',
                l: 'normal',
                mplus: 'normal',
                m: 'normal',
                s: 'normal',
                xs: 'normal',
            },
            lead: {
                m: 'normal',
                s: 'normal',
            },
            list: {
                m: 'normal',
            },
            listNumber: {
                /**
                 * 0.01em / 1%
                 */
                m: '0.01em',
            },
            button: {
                /**
                 * 0.01em / 1%
                 */
                m: '0.01em',
            },
        },
    },
    animation: {
        /**
         * Animation durations for transitions and animations.
         */
        duration: {
            /**
             * Default animation duration usable in most cases.
             */
            default: '0.15s',
        },
    },
};
